import React, { SFC } from 'react'
import { TranslationFunction } from 'react-i18next'

import { Sort, TableColumnSchema } from '../models'
import { TableHeadColumn } from './table-head-column.component'
import { TableRow } from './table-row.component'

import { isPresent } from '../../../shared'

type Props = {
  tableSchema: any
  translate: TranslationFunction
  sort?: Sort
  isSortable?: boolean
  onSortChange?(columnId: string): void
}

const ACTION_COLUMN_ID = 'actions'

const TableHeaderRow: SFC<Props> = ({ tableSchema, children, sort, onSortChange, isSortable = true, translate }) => {
  return (
    <TableRow>
      {tableSchema.map((column: TableColumnSchema<{}>) => {
        if (isActionColumn(column.id)) {
          return <TableHeadColumn key={column.id} data-test={column.id} />
        }

        return (
          <TableHeadColumn
            data-test={column.id}
            key={column.id}
            tight={column.tight}
            sortable={isSortable && column.sortable}
            onSortChange={getColumnSortClick(column.id)}
            sortDirection={getSortDirectionForColumn(column.id)}
          >
            {translate(column.label)}
          </TableHeadColumn>
        )
      })}
    </TableRow>
  )

  function getColumnSortClick(column: string) {
    if (isSortable && isPresent(onSortChange)) {
      return () => onSortChange(column)
    }
  }

  function getSortDirectionForColumn(column: string) {
    if (isPresent(sort)) {
      return sort[column]
    }
  }

  function isActionColumn(columnId: string): boolean {
    return columnId === ACTION_COLUMN_ID
  }
}

export { TableHeaderRow }



// WEBPACK FOOTER //
// ./src/app/shared/smart-table/components/table-header-row.component.tsx